'use client'

import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface SectionProps {
    id?: string
    children: ReactNode
    className?: string
    tone?: 'default' | 'quiet' | 'light'
}

export const Section = ({ id, children, className, tone = 'default' }: SectionProps) => (
    <section
        id={id}
        className={cn(
            'section-y',
            tone === 'quiet' && 'bg-[hsl(var(--deep-black))]/60',
            tone === 'light' && 'bg-[hsl(var(--warm-light))] text-[hsl(var(--deep-black))]',
            className,
        )}
    >
        <div className="container-page">{children}</div>
    </section>
)

interface HeadingProps {
    eyebrow?: string
    title: ReactNode
    text?: ReactNode
    align?: 'center' | 'left'
    className?: string
}

export const SectionHeading = ({ eyebrow, title, text, align = 'center', className }: HeadingProps) => (
    <div className={cn('flex flex-col gap-4', align === 'center' ? 'mx-auto max-w-3xl text-center items-center' : 'max-w-3xl', className)}>
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h2 className="display-2">{title}</h2>
        {text && <p className="lede">{text}</p>}
    </div>
)
